import { SearchService } from '@lib/constants/variants';
import { useSearchService } from '@lib/context/search-service-context';
import { YelpSearchServiceLogo } from '@modules/common/icons/yelp-search-service-logo';
import { GoogleSearchServiceLogo } from '@modules/common/icons/google-search-service-logo';

export const SearchServiceLogo = () => {
    const searchService = useSearchService();
    if (!searchService?.currentSearch) return;
    return (
        <>
            {searchService.currentSearch === SearchService.GOOGLE ?
              <GoogleSearchServiceLogo /> :
              <YelpSearchServiceLogo />
            }
        </>
    )
}